import React, { useRef } from 'react';
import {
  Card,
  SummaryLayout,
  Text,
  useResponsiveParams,
} from 'quanta-ui';
import { ClientService, Layout } from 'quanta-flows/modules/layout';
import { useParams } from 'react-router-dom';
import { Loading } from 'quanta-flows/modules/layout';
import { Error } from 'quanta-flows/modules/layout';
import { INTERMEDIARY_LIST, VIEW_POLICY_FIRE,VIEW_PROPOSAL_FIRESF } from './queries';
import { useQuery } from '@apollo/client';
import PolicyDetailsPanelFire from './policy-details-panel-fire';
import SummaryPanelFire from './policy-details-summary-fire';

export default function ViewPolicyFireSA({ lobProductList }) {
  let nav = ['Policy', 'View Policy'];
  let { customer_id, proposal_no, policy_no } = useParams();
  const coversFormRef = useRef();

  const textSize = useResponsiveParams({
    for_desktop: '3xl',
    for_mobile: '2xl',
    for_iPad: '3xl',
  });

  let { loading, error, data } = useQuery(VIEW_PROPOSAL_FIRESF, {
    fetchPolicy: 'cache-first',
    variables: {
      input: {
        proposalNumber: proposal_no,
        customerID: customer_id,
        productCode: '1132',
      },
    },
  });
const {
    loading: loadingMyIntermediaries,
    error: errorMyIntermediaries,
    data: dataMyIntermediaries,
  } = useQuery(INTERMEDIARY_LIST);

  return loading || loadingMyIntermediaries ? (
    <Loading />
  ) : errorMyIntermediaries || error ? (
    <Error error={errorMyIntermediaries || error} />
  ) : customer_id?.toString()?.toLowerCase() ===
      data?.viewProposalSF?.customerID?.toString()?.toLowerCase() &&
    dataMyIntermediaries?.myIntermediaries?.find(
      (myIntermediary) =>
        myIntermediary?.intermediaryCode
          ?.toString()
          ?.toLowerCase() ===
        data?.viewProposalSF?.intermediaryDetails?.code
          ?.toString()
          ?.toLowerCase(),
    ) ? (
    <Layout
      nav={nav}
      service_type={ClientService}
      title={'View Policy'}
    >
      <SummaryLayout
        summary={
          <>
          {
              <SummaryPanelFire
                forwardedCoversFormRef={coversFormRef}
                proposal_no={proposal_no}
                policy_no={policy_no}
                customer_id={customer_id}
                lobProductList={lobProductList}
              />
            }
          </>
        }
      >
        <PolicyDetailsPanelFire
          forwardedCoversFormRef={coversFormRef}
          proposal_no={proposal_no}
          policy_no={policy_no}
          customer_id={customer_id}
          lobProductList={lobProductList}
        />
      </SummaryLayout>
    </Layout>
  ) : customer_id?.toString()?.toLowerCase() !==
    data?.viewProposalSF?.customerID?.toString()?.toLowerCase() ? (
    <Layout
      nav={nav}
      service_type={ClientService}
      title={'View Policy'}
    >
      <Card className="h-screen" severity={`error`}>
        <Text
          severity={'error'}
          className={`w-full h-full text-center text-${textSize} flex items-center justify-center`}
        >
          Incorrect Customer ID for the given Policy Number.
        </Text>
      </Card>
    </Layout>
  ) : (
    <Layout
      nav={nav}
      service_type={ClientService}
      title={'View Policy'}
    >
      <Card className="h-screen" severity={`error`}>
        <Text
          severity={'error'}
          className={`w-full h-full text-center text-${textSize} flex items-center justify-center`}
        >
          Access denied.You are not allowed to view policy belonging
          to another intermediary.
        </Text>
      </Card>
    </Layout>
  );
}
